module.exports = __webpack_public_path__ + "assets/img/modal-avatar-6e0b128e.png";